/* eslint camelcase: 0 */

import { PermissionsApplication as Data } from '@/typings/api/PermissionsApplication'
import { Model, createMessages } from '@/helpers/Model'


export class PermissionsApplicationModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить сервис',
    edit: 'Редактировать сервис',
    view: (data?: PermissionsApplicationModel) => 'Сервис «{name}»'
      .replace('{name}', data?.name || '...'),
    list: 'Сервисы',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data?: PermissionsApplicationModel) => 'Удаление сервиса «{name}»'
      .replace('{name}', data?.name || '...'),
    delete_all_partly: 'Удаление части выбранных сервисов',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранные сервисы нельзя удалить',

  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
